/*
 *
 *  actions
 *
 */
import {
  //LOAD_EMPLOYEE_LEAVE_RECORD
  LOAD_EMPLOYEE_LEAVE_RECORD,
  LOAD_EMPLOYEE_LEAVE_RECORD_SUCCESS,
  LOAD_EMPLOYEE_LEAVE_RECORD_ERROR,

  LOAD_EMPLOYEE_LIST,
  LOAD_EMPLOYEE_LIST_SUCCESS,
  LOAD_EMPLOYEE_LIST_ERROR,

  LOAD_ATTENDANCE_VIEW,
  LOAD_ATTENDANCE_VIEW_SUCCESS,
  LOAD_ATTENDANCE_VIEW_ERROR,

  LOAD_PROJECT_LIST,
  LOAD_PROJECT_LIST_SUCCESS,
  LOAD_PROJECT_LIST_ERROR,

  LOAD_EMPLOYEE_DROPDOWN,
  LOAD_EMPLOYEE_DROPDOWN_SUCCESS,
  LOAD_EMPLOYEE_DROPDOWN_ERROR,

  LOAD_DOCUMENT,
  LOAD_DOCUMENT_SUCCESS,
  LOAD_DOCUMENT_ERROR

} from "./constants";

export function loadRecordsCacheHit() {
  return {
    // type: LOAD_RECORDS_VALID_CACHE  organization_list
  };
}


//loadEmployeeLeaveRecord
export function loadEmployeeLeaveRecord(searchFilter) {
  return {
    type: LOAD_EMPLOYEE_LEAVE_RECORD,
    searchFilter,
  };
}

export function loadEmployeeLeaveRecordSuccess( employeeLeaveRecord_list, success) {
  return {
    type: LOAD_EMPLOYEE_LEAVE_RECORD_SUCCESS,
     employeeLeaveRecord_list,
    success,
  };
}

export function loadEmployeeLeaveRecordError(error) {
  return {
    type: LOAD_EMPLOYEE_LEAVE_RECORD_ERROR,
    error,
  };
}


//loadEmployeeList
export function loadEmployeeList(searchFilter) {
  return {
    type: LOAD_EMPLOYEE_LIST,
    searchFilter,
  };
}

export function loadEmployeeListSuccess( employee_list, success) {
  return {
    type: LOAD_EMPLOYEE_LIST_SUCCESS,
     employee_list,
    success,
  };
}

export function loadEmployeeListError(error) {
  return {
    type: LOAD_EMPLOYEE_LIST_ERROR,
    error,
  };
}


//loadEmployeeDropdown
export function loadEmployeeDropdown(searchFilter) {
  return {
    type: LOAD_EMPLOYEE_DROPDOWN,
    searchFilter,
  };
}

export function loadEmployeeDropdownSuccess(dropDownList, success) {
  return {
    type: LOAD_EMPLOYEE_DROPDOWN_SUCCESS,
    dropDownList,
    success,
  };
}

export function loadEmployeeDropdownError(error) {
  return {
    type: LOAD_EMPLOYEE_DROPDOWN_ERROR,
    error,
  };
}


//loadDocument
export function loadDocument(searchFilter) {
  return {
    type: LOAD_DOCUMENT,
    searchFilter,
  };
}

export function loadDocumentSuccess(documentList, success) {
  return {
    type: LOAD_DOCUMENT_SUCCESS,
    documentList,
    success,
  };
}

export function loadDocumentError(error) {
  return {
    type: LOAD_DOCUMENT_ERROR,
    error,
  };
}

//loadAttendanceView

export function loadAttendanceView(searchFilter){
  return{
    type:LOAD_ATTENDANCE_VIEW,
    searchFilter,
  }
}

export function loadAttendanceViewSuccess(attendanceViewList,success){
  return{
    type:LOAD_ATTENDANCE_VIEW_SUCCESS,
    attendanceViewList,
    success
  }
}

export function loadAttendanceViewError(error){
  return{
    type:LOAD_ATTENDANCE_VIEW_ERROR,
    error
  }
}

export function loadProjectList(projectarg){
  return{
    type:LOAD_PROJECT_LIST,
    projectarg,
  }
}

export function loadProjectListSuccess(projectlist,success){
  return{
    type:LOAD_PROJECT_LIST_SUCCESS,
    projectlist,
    success,
  }
}

export function loadProjectListError(error){
  return{
    type:LOAD_PROJECT_LIST_ERROR,
    error,
  }
}

const actions = {
 
  loadEmployeeLeaveRecord,
  loadEmployeeLeaveRecordSuccess,
  loadEmployeeLeaveRecordError,

  loadEmployeeList,
  loadEmployeeListSuccess,
  loadEmployeeListError,

  loadDocument,
  loadDocumentSuccess,
  loadDocumentError,

  loadAttendanceView,
  loadAttendanceViewSuccess,
  loadAttendanceViewError,

  loadProjectList,
  loadProjectListSuccess,
  loadProjectListError,
 
  loadRecordsCacheHit,
  
};

export default actions;
